import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useState } from "react";
import { DynamicFormControl, SelectOption } from "../../../";
import LocalizedStrings, { LocalizedStringsMethods } from 'react-localization';
import { getLocalizedStringMethods, localizeText, useTranslateDetection } from "../../helpers/translate-helper";

function SelectControl(props: DynamicFormControl) {
    const [value, setValue] = useState<string | [] | null>(props.value ?? null);
    const [customLabelClass, setCustomLabelClass] = useState<string>('MuiFormLabel-root');

    const { currentLanguage } = useTranslateDetection();

    const handleChange = (event: any) => {
        const value = event.target.value as string;

        if (props.setState) {
            props.setState(value);
        }
        setValue(value);

        if (value) {
            setCustomLabelClass('MuiFormLabel-root MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled');
        }
    };

    if (props.updater != null) {
        props.updater.setValue = value => {
            setValue(value === '' ? null : value);
        };
    }

    let label = props.label;
    let strings: LocalizedStringsMethods | null = getLocalizedStringMethods(props, currentLanguage);

    if (strings != null && label != null) {
        const localization = localizeText(strings, label);
        label = localization.localization;
    }

    return (
        <FormControl fullWidth={props.fullWidth}>

            {
                props.customLabel ?
                    <label className={customLabelClass}>{label}{props.required ? '*' : ''}</label> :

                    <InputLabel
                        id={props.id + '-label'}>
                        {label + (props.required ? '*' : '')}
                    </InputLabel>
            }
            <Select
                labelId={props.id + '-label'}
                id={props.id}
                value={value || (props.multiSelect ? [] : '')}
                onChange={handleChange}
                autoComplete={props.autoComplete}
                autoFocus={props.autoFocus}
                name={props.name}
                style={{ marginTop: props.customLabel ? '0' : '' }}
                placeholder={props.placeholder}
                required={props.required}
                rows={props.rows}
                maxRows={props.rowsMax}
                label={label}
                multiline={props.multiline}
                multiple={props.multiSelect}
                key={props.label}
                disabled={props.disabled}
                inputProps={{ name: props.name ?? label }}
            >
                {props.selectOptions?.map(x => {
                    const option = x as SelectOption;
                    let optionLabel = option?.label ?? x;
                    const optionValue = option?.value ?? x;

                    let hasLocalization = false;
                    if (strings != null) {
                        const localization = localizeText(strings, optionLabel);
                        hasLocalization = localization.hasMatch;
                        optionLabel = localization.localization;
                    }

                    return (
                        <MenuItem value={optionValue} key={optionValue} className={props.skipTranslation || hasLocalization ? "notranslate" : undefined}>{optionLabel}</MenuItem>
                    )
                })}

                {props.selectPropertyOptions?.map(x => {
                    const option = x.label as SelectOption;
                    let optionLabel = option?.label ?? x;
                    const optionValue = option?.value ?? x;

                    let hasLocalization = false;

                    if (strings != null) {
                        const localization = localizeText(strings, optionLabel);
                        hasLocalization = localization.hasMatch;
                        optionLabel = localization.localization;
                    }

                    return (
                        <MenuItem value={optionValue} key={x.jsonName} className={props.skipTranslation || hasLocalization ? "notranslate" : undefined}>{optionLabel}</MenuItem>
                    )
                })}


            </Select>
        </FormControl>
    )
}


export default SelectControl;